import React from "react";
import "./PoseOverlay.css";

const PoseOverlay = ({
  status = "pending",
  instruction = "Align your face within the guide",
}) => {
  const getStatusClass = () => {
    switch (status) {
      case "success":
        return "status-success";
      case "error":
        return "status-error";
      case "warning":
        return "status-warning";
      default:
        return "";
    }
  };

  return (
    <div className={`pose-overlay-container ${getStatusClass()}`}>
      <div className="pose-face-guide">
        {/* Avatar Silhouette */}
        <div className="avatar-outline">
          <svg viewBox="0 0 200 250" preserveAspectRatio="xMidYMid meet">
            {/* Head/Face Outline */}
            <path
              d="M100,30 C60,30 40,60 40,100 C40,150 70,180 100,180 C130,180 160,150 160,100 C160,60 140,30 100,30 Z"
              fill="none"
              className="outline-path"
            />
            {/* Shoulders Outline */}
            <path
              d="M40,180 C20,185 5,210 5,240 L195,240 C195,210 180,185 160,180"
              fill="none"
              className="outline-path"
            />
          </svg>
        </div>
      </div>

      {/* Techy Corners */}
      <div className="corner top-left"></div>
      <div className="corner top-right"></div>
      <div className="corner bottom-left"></div>
      <div className="corner bottom-right"></div>

      <div className="pose-instruction">{instruction}</div>
    </div>
  );
};

export default PoseOverlay;
